import { defineComponent as _defineComponent } from 'vue'
interface Props {
  menu?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterBottomMenu',
  props: {
    menu: { default: () => [] }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})